import request from '@/utils/request'

export { getUploadTempSignature } from '../background/api'

export function getProductList(params = {}) {
  return request.get('/shop/products/product_list', params)
}

export function getProductDetail(productId) {
  return request.get('/shop/products/detail', { product_id: productId })
}

export function createProduct(data) {
  return request.post('/shop/products/create', data)
}

export function updateProduct(data) {
  return request.post('/shop/products/update', data)
}

export function deleteProduct(productId) {
  return request.post('/shop/products/delete', { product_id: productId })
}

export function uploadProductImage(data) {
  return request.post('/shop/products/images/upload', data)
}

export function deleteProductImage(imageId) {
  return request.post('/shop/products/images/delete', { image_id: imageId })
}

export function sortProductImage(imageId, sortOrder) {
  return request.post('/shop/products/images/sort', {
    image_id: imageId,
    sort_order: Number(sortOrder)
  })
}
